/* eslint-disable consistent-return */
import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline'

import { Logger, LoggerTypes } from '../../utils'
import { Button, buttonModes, buttonTypes } from '../../components'

/**
 * Display a confirm popin
 *
 * @param {object} param Ex: {
 *                          openDialog: true // hook value
 *                          setOpenDialog: () => { ... }  // hook function
 *                          title: 'Confirm'
 *                          message: 'Are you sure you want to ...'
 *                          onClose: (bool) => bool // where bool can be `true` or `false`
 *                        }
 * @returns {Dialog}
 */
export const DialogConfirm = ({ openDialog, setOpenDialog, title, message, onClose }) => {
  const { t } = useTranslation()

  const onCloseDialog = () => setOpenDialog(false)

  const onClickNo = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'DialogConfirm.onClickNo()', { openDialog, onClose })

    onCloseDialog()

    if (typeof onClose === 'function') {
      onClose(false)
    }
  }

  const onClickYes = (e) => {
    e.stopPropagation()

    Logger.trace(LoggerTypes.CONTROLLER, 'DialogConfirm.onClickYes()', { openDialog, onClose })

    onCloseDialog()

    if (typeof onClose === 'function') {
      onClose(true)
    }
  }

  Logger.trace(LoggerTypes.CONTAINER, 'DialogConfirm.render()', { openDialog, onClose })

  return (
    <Dialog
      open={openDialog}
      // onClose={onCloseDialog} // <-- close while clicking on background
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          mode={buttonModes.SECONDARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.no')}
          icon={<CloseIcon />}
          onClick={onClickNo}
        />
        <Button
          mode={buttonModes.PRIMARY_ACTION}
          type={buttonTypes.BUTTON}
          text={t('common.yes')}
          icon={<DeleteOutlineIcon />}
          onClick={onClickYes}
        />
      </DialogActions>
    </Dialog>
  )
}

DialogConfirm.displayName = 'DialogConfirm'

DialogConfirm.propTypes = {
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  onClose: PropTypes.func
}

DialogConfirm.defaultProps = {
  openDialog: false,
  setOpenDialog: () => {},
  title: '',
  message: '',
  onClose: null
}
